exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-test-badge{height:.875rem;display:inline-flex;padding:0 .25rem;border-radius:.125rem;background-color:var(--fts-light);color:var(--fts-primary);text-transform:uppercase;font-weight:400;font-style:normal;font-size:.625rem;line-height:.875rem;white-space:normal}", ""]);

// exports
